// src/my-account/data.js

export default {
  user: {
    id: 1,
    username: "yosef",
    email: "yosefi8665@gmail.com",
    name: {
      first: "יוסף",
      last: "אלישיוב",
    },
    billing: {
      first_name: "yosef",
      last_name: "elishayov",
      company: "",
      address_1: "ריינס",
      address_2: "",
      city: "בני ברק",
      postcode: "5137809",
      country: "IL",
      state: "",
      phone: "0504103486",
      email: "yosefi8665@gmail.com",
    },
    shipping: {
      first_name: "yosef",
      last_name: "elishayov",
      company: "",
      address_1: "ריינס",
      address_2: "",
      city: "בני ברק",
      postcode: "5137809",
      country: "IL",
      state: "",
    },
  },
  orders: [
    {
      id: 22962,
      number: "22962",
      status: "completed",
      date_created: "2025-11-19T11:31:10+00:00",
      total: 0,
      currency: "ILS",
      items: [
        {
          product_id: 22959,
          variation_id: 0,
          name: "הארכת רישיון",
          quantity: 1,
          total: 0,
        },
      ],
    },
    {
      id: 22961,
      number: "22961",
      status: "completed",
      date_created: "2025-11-19T11:27:36+00:00",
      total: 0,
      currency: "ILS",
      items: [
        {
          product_id: 22960,
          variation_id: 0,
          name: "רישיון",
          quantity: 1,
          total: 0,
        },
      ],
    },
    {
      id: 22893,
      number: "22893",
      status: "completed",
      date_created: "2025-11-10T10:16:35+00:00",
      total: 0,
      currency: "ILS",
      items: [
        {
          product_id: 22892,
          variation_id: 0,
          name: "רישיונות",
          quantity: 1,
          total: 0,
        },
      ],
    },
    {
      id: 20119,
      number: "20119",
      status: "pending",
      date_created: "2025-06-30T15:01:02+00:00",
      total: 0,
      currency: "ILS",
      items: [],
    },
    {
      id: 19155,
      number: "19155",
      status: "processing",
      date_created: "2025-05-13T22:00:42+00:00",
      total: 0,
      currency: "ILS",
      items: [
        {
          product_id: 0,
          variation_id: 0,
          name: "מזרן דור לטקס פולירון",
          quantity: 1,
          total: 0,
        },
      ],
    },
    {
      id: 656565,
      number: "19155",
      status: "processing",
      date_created: "2025-05-13T22:00:42+00:00",
      total: 0,
      currency: "ILS",
      items: [
        {
          product_id: 0,
          variation_id: 0,
          name: "מזרן דור לטקס פולירון",
          quantity: 1,
          total: 0,
        },
      ],
    },
  ],
  downloads: [
    {
      download_id: "fc0fee62-d4f9-4648-93ea-019d6f3f7016",
      product_id: 22960,
      product_name: "רישיון",
      download_name: "whizmanage-pro.zip",
      download_url:
        "http://localhost/wordpress/?download_file=22960&order=wc_order_uz1mow7cnHTWK&email=yosefi8665%40gmail.com&key=fc0fee62-d4f9-4648-93ea-019d6f3f7016",
      downloads_remaining: "",
      access_expires: null,
    },
    {
      download_id: "ee1cd16c-8d4f-45df-850a-0da81160ea4b",
      product_id: 22959,
      product_name: "הארכת רישיון",
      download_name: "whizmanage-pro.zip",
      download_url:
        "http://localhost/wordpress/?download_file=22959&order=wc_order_MNmr6ncsAM1ka&email=yosefi8665%40gmail.com&key=ee1cd16c-8d4f-45df-850a-0da81160ea4b",
      downloads_remaining: "",
      access_expires: null,
    },
  ],
  licenses: [
    {
      id: 1,
      orderId: 242,
      productId: 241,
      userId: 1,
      licenseKey: "PREC4B3-BCDC-A3C2-C434-1D1B-3ABCSUF",
      expiresAt: "2025-04-15 12:48:18",
      validFor: "365",
      source: 1,
      status: 2,
      timesActivated: 1,
      timesActivatedMax: 0,
      createdAt: "2024-04-15 12:48:18",
      createdBy: 1,
      updatedAt: "2024-04-15 12:57:38",
      updatedBy: 1,
      activationData: [
        {
          id: 1,
          token: "020489f8fc144feeb3c636bf48d2cb2f8671324c",
          license_id: 1,
          label: null,
          source: 2,
          ip_address: "::1",
          user_agent: "PostmanRuntime/7.32.1",
          meta_data: [{ domain: "example-shop.com" }],
          created_at: "2024-04-15 12:57:38",
          updated_at: null,
          deactivated_at: null,
        },
      ],
    },
    {
      id: 2,
      orderId: 243,
      productId: 241,
      userId: 1,
      licenseKey: "PREA1B4-12A2-C3D4-BC44-4432-3DDDSUF",
      expiresAt: "2025-04-16 07:24:00",
      validFor: "365",
      source: 1,
      status: 2,
      timesActivated: 12,
      timesActivatedMax: 0,
      createdAt: "2024-04-16 07:24:00",
      createdBy: 1,
      updatedAt: "2024-05-05 09:27:15",
      updatedBy: 1,
      activationData: [
        {
          id: 7,
          token: "b7cfd0425b1c9ae31eba652168aaa6e18ebeff10",
          license_id: 2,
          label: null,
          source: 2,
          ip_address: "::1",
          user_agent:
            "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/124.0.0.0 Safari/537.36",
          meta_data: [{ domain: "my-store.co.il" }],
          created_at: "2024-05-05 08:17:25",
          updated_at: null,
          deactivated_at: null,
        },
        {
          id: 8,
          token: "37aaaa700cbc5b02815938316559be6ab3a63f53",
          license_id: 2,
          label: null,
          source: 2,
          ip_address: "::1",
          user_agent:
            "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/124.0.0.0 Safari/537.36",
          meta_data: [{ domain: "shop-online.com" }],
          created_at: "2024-05-05 08:18:40",
          updated_at: null,
          deactivated_at: null,
        },
        {
          id: 9,
          token: "73f7035ed864cc3c143c49095cf8464c77f74403",
          license_id: 2,
          label: null,
          source: 2,
          ip_address: "::1",
          user_agent:
            "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/124.0.0.0 Safari/537.36",
          meta_data: [{ domain: "ecommerce-site.net" }],
          created_at: "2024-05-05 08:26:12",
          updated_at: null,
          deactivated_at: null,
        },
        {
          id: 10,
          token: "cd8743234155abcbee2f8992e4bc410fa29fa61c",
          license_id: 2,
          label: null,
          source: 2,
          ip_address: "::1",
          user_agent:
            "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/124.0.0.0 Safari/537.36",
          meta_data: [{ domain: "webshop.org" }],
          created_at: "2024-05-05 08:30:41",
          updated_at: null,
          deactivated_at: null,
        },
        {
          id: 11,
          token: "61a50294ff72098a4881e99cd91b51dc0c4065dc",
          license_id: 2,
          label: null,
          source: 2,
          ip_address: "::1",
          user_agent:
            "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/124.0.0.0 Safari/537.36",
          meta_data: [{ domain: "retail-hub.com" }],
          created_at: "2024-05-05 08:34:03",
          updated_at: null,
          deactivated_at: null,
        },
        {
          id: 12,
          token: "f30d08c82bdd3e6698a9a201a87387fc3b7f9489",
          license_id: 2,
          label: null,
          source: 2,
          ip_address: "::1",
          user_agent:
            "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/124.0.0.0 Safari/537.36",
          meta_data: [{ domain: "digital-market.io" }],
          created_at: "2024-05-05 08:59:20",
          updated_at: null,
          deactivated_at: null,
        },
        {
          id: 13,
          token: "4339003e28d89c2e6497a4fcc5c764cce0dd732a",
          license_id: 2,
          label: null,
          source: 2,
          ip_address: "::1",
          user_agent:
            "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/124.0.0.0 Safari/537.36",
          meta_data: [{ domain: "online-boutique.com" }],
          created_at: "2024-05-05 09:00:39",
          updated_at: null,
          deactivated_at: null,
        },
        {
          id: 14,
          token: "6e1699cbdba021bb934708aaaff3a34d5a076e31",
          license_id: 2,
          label: null,
          source: 2,
          ip_address: "::1",
          user_agent:
            "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/124.0.0.0 Safari/537.36",
          meta_data: [{ domain: "fashion-store.co.il" }],
          created_at: "2024-05-05 09:12:58",
          updated_at: null,
          deactivated_at: null,
        },
        {
          id: 15,
          token: "da6361b30866bae9254b97040502cc380b40d511",
          license_id: 2,
          label: null,
          source: 2,
          ip_address: "::1",
          user_agent:
            "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/124.0.0.0 Safari/537.36",
          meta_data: [{ domain: "tech-gadgets.com" }],
          created_at: "2024-05-05 09:23:27",
          updated_at: null,
          deactivated_at: null,
        },
        {
          id: 16,
          token: "36c371bcc503936e253fc941cf6249262d1fa8dd",
          license_id: 2,
          label: null,
          source: 2,
          ip_address: "::1",
          user_agent:
            "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/124.0.0.0 Safari/537.36",
          meta_data: [{ domain: "home-decor.net" }],
          created_at: "2024-05-05 09:25:27",
          updated_at: null,
          deactivated_at: null,
        },
        {
          id: 17,
          token: "93fff7596c86df2bb7f680697342ec34498f3dd2",
          license_id: 2,
          label: null,
          source: 2,
          ip_address: "::1",
          user_agent:
            "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/124.0.0.0 Safari/537.36",
          meta_data: [{ domain: "sports-gear.org" }],
          created_at: "2024-05-05 09:25:50",
          updated_at: null,
          deactivated_at: null,
        },
        {
          id: 18,
          token: "2b094d583dc239a87996475b8fcf35638f74bde5",
          license_id: 2,
          label: null,
          source: 2,
          ip_address: "::1",
          user_agent:
            "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/124.0.0.0 Safari/537.36",
          meta_data: [{ domain: "beauty-products.co.il" }],
          created_at: "2024-05-05 09:27:15",
          updated_at: null,
          deactivated_at: null,
        },
      ],
    },
    {
      id: 3,
      orderId: 245,
      productId: 241,
      userId: 1,
      licenseKey: "PRE1AA1-A3D2-1A1A-413A-CBDA-CD34SUF",
      expiresAt: "2025-04-17 08:40:34",
      validFor: "365",
      source: 1,
      status: 2,
      timesActivated: 1,
      timesActivatedMax: 0,
      createdAt: "2024-04-17 08:40:34",
      createdBy: 1,
      updatedAt: "2024-05-08 06:45:47",
      updatedBy: 1,
      activationData: [
        {
          id: 21,
          token: "2f20b6d155e6d06ac95838f5a973b5fbf83f0a37",
          license_id: 3,
          label: null,
          source: 2,
          ip_address: "::1",
          user_agent:
            "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/124.0.0.0 Safari/537.36",
          meta_data: [{ domain: "pet-supplies.com" }],
          created_at: "2024-05-08 06:45:47",
          updated_at: null,
          deactivated_at: null,
        },
      ],
    },
    {
      id: 4,
      orderId: 254,
      productId: 241,
      userId: 1,
      licenseKey: "PRE12CA-B4A2-A32B-2D4C-1B22-AC1ASUF",
      expiresAt: "2025-05-02 08:00:19",
      validFor: "365",
      source: 1,
      status: 2,
      timesActivated: 1,
      timesActivatedMax: 0,
      createdAt: "2024-05-02 08:00:19",
      createdBy: 1,
      updatedAt: "2024-05-02 08:00:53",
      updatedBy: 1,
      activationData: [
        {
          id: 2,
          token: "df290315e63d28544d42efdf56e3dc34e0c3a057",
          license_id: 4,
          label: null,
          source: 2,
          ip_address: "::1",
          user_agent:
            "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/124.0.0.0 Safari/537.36",
          meta_data: [{ domain: "grocery-delivery.co.il" }],
          created_at: "2024-05-02 08:00:53",
          updated_at: null,
          deactivated_at: null,
        },
      ],
    },
    {
      id: 5,
      orderId: 255,
      productId: 241,
      userId: 1,
      licenseKey: "PREDC32-21DD-414C-CCDA-4222-2D2BSUF",
      expiresAt: "2025-05-02 08:01:39",
      validFor: "365",
      source: 1,
      status: 2,
      timesActivated: 2,
      timesActivatedMax: 0,
      createdAt: "2024-05-02 08:01:39",
      createdBy: 1,
      updatedAt: "2024-05-02 08:21:14",
      updatedBy: 1,
      activationData: [
        {
          id: 3,
          token: "c25ea4d670a769afe23691fccf5d65d90b3d1323",
          license_id: 5,
          label: null,
          source: 2,
          ip_address: "::1",
          user_agent:
            "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/124.0.0.0 Safari/537.36",
          meta_data: [{ domain: "jewelry-shop.com" }],
          created_at: "2024-05-02 08:02:06",
          updated_at: null,
          deactivated_at: null,
        },
        {
          id: 4,
          token: "7fe35841cbf200e7c2e53e67a8d89c6417b6920a",
          license_id: 5,
          label: null,
          source: 2,
          ip_address: "::1",
          user_agent:
            "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/124.0.0.0 Safari/537.36",
          meta_data: [{ domain: "book-store.net" }],
          created_at: "2024-05-02 08:21:14",
          updated_at: null,
          deactivated_at: null,
        },
      ],
    },
    {
      id: 6,
      orderId: 256,
      productId: 241,
      userId: 1,
      licenseKey: "PRECCBB-A4A4-ACB2-314D-3CB4-4443SUF",
      expiresAt: "2024-05-01 00:00:00",
      validFor: null,
      source: 1,
      status: 2,
      timesActivated: 1,
      timesActivatedMax: 1,
      createdAt: "2024-05-02 08:22:39",
      createdBy: 1,
      updatedAt: "2024-05-02 09:27:17",
      updatedBy: 1,
      activationData: [
        {
          id: 5,
          token: "3ec5f72c0638b9315d72bc5fdf165c8e49e75ed0",
          license_id: 6,
          label: null,
          source: 2,
          ip_address: "::1",
          user_agent:
            "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/124.0.0.0 Safari/537.36",
          meta_data: [{ domain: "music-instruments.org" }],
          created_at: "2024-05-02 08:23:09",
          updated_at: null,
          deactivated_at: null,
        },
      ],
    },
    {
      id: 7,
      orderId: 256,
      productId: 241,
      userId: 1,
      licenseKey: "PREBAB4-DDCD-21CD-B33D-4C1B-3CACSUF",
      expiresAt: "2025-05-02 08:22:39",
      validFor: "365",
      source: 1,
      status: 2,
      timesActivated: 1,
      timesActivatedMax: 1,
      createdAt: "2024-05-02 08:22:39",
      createdBy: 1,
      updatedAt: "2024-05-02 10:59:54",
      updatedBy: 1,
      activationData: [
        {
          id: 6,
          token: "0bd44163f1ef3b0cc6087f35c88113a3a83c5d0f",
          license_id: 7,
          label: null,
          source: 2,
          ip_address: "::1",
          user_agent:
            "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/124.0.0.0 Safari/537.36",
          meta_data: [{ domain: "outdoor-gear.co.il" }],
          created_at: "2024-05-02 10:59:54",
          updated_at: null,
          deactivated_at: null,
        },
      ],
    },
    {
      id: 8,
      orderId: 254,
      productId: 241,
      userId: 1,
      licenseKey: "1234-4856-1456-2548",
      expiresAt: "2024-06-05 00:00:00",
      validFor: null,
      source: 2,
      status: 2,
      timesActivated: null,
      timesActivatedMax: 1,
      createdAt: "2024-05-05 09:51:09",
      createdBy: 1,
      updatedAt: "2024-05-05 09:51:52",
      updatedBy: 1,
      activationData: [],
    },
    {
      id: 9,
      orderId: 259,
      productId: 241,
      userId: 1,
      licenseKey: "PREB2B2-3433-CD33-A44D-31DC-44B2SUF",
      expiresAt: "2025-05-06 08:53:57",
      validFor: "365",
      source: 1,
      status: 2,
      timesActivated: 1,
      timesActivatedMax: 1,
      createdAt: "2024-05-06 08:53:57",
      createdBy: 1,
      updatedAt: "2024-05-06 08:54:22",
      updatedBy: 1,
      activationData: [
        {
          id: 19,
          token: "acd4b6d92d1a0d40a2563935a8e3e777e4c8761a",
          license_id: 9,
          label: null,
          source: 2,
          ip_address: "::1",
          user_agent:
            "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/124.0.0.0 Safari/537.36",
          meta_data: [{ domain: "myshop.com" }],
          created_at: "2024-05-06 08:54:22",
          updated_at: null,
          deactivated_at: null,
        },
      ],
    },
    {
      id: 10,
      orderId: 264,
      productId: 241,
      userId: 1,
      licenseKey: "PREBDCC-CACC-AB2D-3DD4-3BBB-31A2SUF",
      expiresAt: "2025-05-07 00:00:00",
      validFor: null,
      source: 1,
      status: 2,
      timesActivated: 0,
      timesActivatedMax: 1,
      createdAt: "2024-05-07 09:22:02",
      createdBy: 1,
      updatedAt: "2024-08-11 08:19:43",
      updatedBy: 1,
      activationData: [],
    },
    {
      id: 11,
      orderId: 1948,
      productId: 241,
      userId: 1,
      licenseKey: "PRE4DCC-B1A2-3412-4121-3A34-4C1ASUF",
      expiresAt: "2025-08-07 10:19:09",
      validFor: "365",
      source: 1,
      status: 2,
      timesActivated: null,
      timesActivatedMax: 1,
      createdAt: "2024-08-07 10:19:09",
      createdBy: 1,
      updatedAt: "2024-08-07 10:19:10",
      updatedBy: 1,
      activationData: [],
    },
    {
      id: 12,
      orderId: 22893,
      productId: 22892,
      userId: 1,
      licenseKey: "PRE4A3C-1B13-3A22-A2DB-D3D1-3A33SUF",
      expiresAt: "2026-11-10 00:00:00",
      validFor: null,
      source: 1,
      status: 3,
      timesActivated: null,
      timesActivatedMax: 1,
      createdAt: "2025-11-10 08:16:44",
      createdBy: 1,
      updatedAt: "2025-11-10 08:37:00",
      updatedBy: 1,
      activationData: [],
    },
    {
      id: 13,
      orderId: 22961,
      productId: 22960,
      userId: 1,
      licenseKey: "PRE4A4B-CD1B-3B11-AB1B-DA23-BB44SUF",
      expiresAt: "2027-11-19 09:27:46",
      validFor: "365",
      source: 1,
      status: 2,
      timesActivated: null,
      timesActivatedMax: 1,
      createdAt: "2025-11-19 09:27:47",
      createdBy: 1,
      updatedAt: "2025-11-19 09:27:47",
      updatedBy: 1,
      activationData: [],
    },
  ],
  affiliate: {
    affiliate_id: 1,
    status: "active",
    hits: 0,
    earned_total: 0,
    pending_total: 0,
  },
};